/**
 * alerts service
 */

import { downloadFile } from '../../pages/cm/utils/common';
import { AMLS_NS_IAD } from '../../pages/constants/globalConstants';
import { getLocalTimezone } from '../../util/timezone';
import { apiConfig, createAxiosServiceInstance } from '../api';

const axios = createAxiosServiceInstance();
const baseUrlDownload = `${apiConfig.serviceApi}${AMLS_NS_IAD}/onDemandScreening/download`;
const baseUrlSendToCM = `${apiConfig.serviceApi}${AMLS_NS_IAD}/onDemandScreening/sendToCm`;
const baseUrlCustomerType = `${apiConfig.serviceApi}${AMLS_NS_IAD}/customerType`;

const headers = {
  'Content-Type': 'application/json',
  Authorization: localStorage.getItem('id_token')
};

export async function downloadAlertsApi(payload) {
  const { ids, fileName } = payload;
  let params = {
    alertIds: ids.toString()
  };
  const header = {
    'Content-Type': 'application/json', // or 'text/csv' based on your server's requirements
    'Content-Disposition': 'attachment;filename=data.csv',
    'Access-Control-Expose-Headers': 'Content-Type, Content-Disposition',
    'Time-Zone': getLocalTimezone()
  };

  return await axios
    .get(baseUrlDownload, { headers: header, params, responseType: 'blob' })
    .then((res) => {
      downloadFile(res.data, fileName);
      return res.data;
    });
}

export async function sendToCMApi(payload) {
  const data = { alertIds: payload?.ids };
  const res = await axios.post(baseUrlSendToCM, data, { headers });

  if (res.status !== 200) {
    throw new Error(res?.data?.msg ?? 'Failed to Send to CM');
  }

  return res.data;
}

export async function getCustomerTypesSegmentApi() {
  return axios.get(baseUrlCustomerType, { headers }).then((res) => {
    return res.data;
  });
}
